import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M8 3.839 3.01 6.333 8 8.828l4.99-2.495L8 3.84Zm-.2-1.531c.132-.025.268-.025.4 0 .157.03.297.101.358.132l.016.008 6.428 3.215a.75.75 0 0 1 0 1.341l-6.428 3.214-.016.008a1.342 1.342 0 0 1-.358.133 1.082 1.082 0 0 1-.4 0 1.342 1.342 0 0 1-.358-.133l-.016-.008L.998 7.004a.75.75 0 0 1 0-1.341l6.428-3.215.016-.008c.061-.03.2-.103.358-.132ZM.662 8.665a.75.75 0 0 1 1.007-.336L8 11.495l6.331-3.166a.75.75 0 1 1 .671 1.342l-6.428 3.214-.016.008c-.061.031-.201.103-.358.132a1.086 1.086 0 0 1-.4 0 1.35 1.35 0 0 1-.358-.132l-.016-.008L.998 9.671a.75.75 0 0 1-.336-1.006Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  c
];
function r(a, d) {
  return e(), l("svg", o, [...n]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
